import { ref } from 'vue'

const snackbar = ref({
  show: false,
  text: '',
  color: 'success',
  timeout: 3000
})

export function useSnackbar() {
  const showSnackbar = (text, color = 'success') => {
    snackbar.value = {
      show: true,
      text,
      color,
      timeout: 3000
    }
  }

  return {
    snackbar,
    showSnackbar
  }
} 